import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import SingleLineField from '../../SingleLineField';
import UrlSpaceFixButton from '../../UrlSpaceFixButton';
import { httpsUrlRule, noSpaceRule } from '../../../../utils/validators';

const LandingPageField: React.FC = () => {
  const { watch, trigger } = useFormContext();
  const landingPage = watch('landingPage') || '';
  const [showWarning, setShowWarning] = useState(false);
  const hasLandingPage = landingPage !== '';

  // Check if landingPage exceeds 600 characters
  useEffect(() => {
    setShowWarning(landingPage.length > 600);
  }, [landingPage]);

  useEffect(() => {
    if (!hasLandingPage) return;
    trigger('landingPage');
  }, [hasLandingPage, trigger]);

  return (
    <>
      <SingleLineField
        top={true}
        label='Landing Page'
        htmlfor='landingPage'
        required
        type='url'
        rules={{
          validate: {
            noSpace: noSpaceRule,
            format: httpsUrlRule,
          }
        }}
        footer={<UrlSpaceFixButton name="landingPage" requireHttps />}
        maxLetters="600"
      />
      {showWarning && (
        <div className="text-yellow-600 text-sm mt-1">
          Field does allow more than 600 characters.
        </div>
      )}
    </>
  );
};

export default LandingPageField;
